import { processInviteCode } from '../../api/inviteCodes';
import { getUser, updateUser } from '../../api/users';
import firebase, { auth, provider } from '../firebase.js';

//TODO oof, tests ?
const handleInviteCodeStuff = ({ uid }) => {
  const localStorageKey = 'inviteCode';
  const inviteCode = window.localStorage.getItem(localStorageKey);
  inviteCode &&
    processInviteCode(
      { uid, inviteCode },
      window.localStorage.removeItem(localStorageKey)
    );
};

export const login = (callback) => {
  auth
    .signInWithPopup(provider)
    .then((result) => {
      const {
        displayName,
        email,
        metadata: { a: creationTimestamp },
        photoURL,
        uid,
      } = result.user;

      getUser(uid, (user) => {
        const isNewUser = !user;

        updateUser(
          {
            uid,
            user: {
              displayName,
              email,
              photoURL,
              joined: new Date(parseInt(creationTimestamp)),
              lastLogin: firebase.firestore.FieldValue.serverTimestamp(),
            },
          },
          () =>
            getUser(uid, (user) => {
              callback && typeof callback === 'function' && callback(user);
            })
        );

        if (isNewUser) {
          handleInviteCodeStuff({ uid });
          //TODO newbie announcement and other new user stuff
        }
      });
    })
    .catch((error) => {
      // Don't show error for user-initiated cancellation
      if (error.code !== 'auth/popup-closed-by-user') {
        console.error('Login error:', error);
      }
    });
};

export const logoff = (callback) => {
  auth.signOut().then(() => {
    callback && typeof callback === 'function' && callback();
  });
};
